<template>
    <div class="pd-page">
        <div class="pd-page-header">发泡橡塑加工-MES系统</div>
        <div class="pd-page-body">
            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>企业类型
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>橡塑</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户介绍
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>某节能科技有限公司是集绝热保温、吸音降噪材料的研发、制造、服务于一体的节能环保型企业。集团拥有六个子公司和八个产业园区，公司生产橡塑海绵制品、玻璃棉制品和硅酸铝制品以及岩棉等高端绝热保温材料，广泛适用于建筑、中央空调、冰箱制冷、石油化工、船舶机车、航天航空、热电、火电等行业。</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户痛点
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>多个工厂，生产数据割裂，产品质量偏差大，制造成本不统一</li>
                        <li>产线设备未联网，无法为生产提供数据支撑</li>
                        <li>采用EXCEL排产，变动靠微信群和电话通知，效率低，出错率大</li>
                        <li>每个分厂需要安排单独计划部门，计划排程效果参差不齐，效率低</li>
                        <li>质量数据虽有留档，但无数据应用</li>
                        <li>生产过程数据无法实时上报</li>
                        <li>库管人工填报出入库数据，数据滞后，准确性差</li>
                        <li>无法实现物料溯源，无法实现原料成本最优化选择</li>
                        <li>质量稳定性主要靠核心技术人员，无法实现质量与工艺联动</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>解决方案
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>多维数据建模：支持建立集团-公司-工厂-车间-班组-工人多级管理模式，区分各层级功能权限和数据权限</li>
                        <li>资源有效整合：对客户现有的CRM、ERP等系统做集成数据采集，不改变用户使用习惯，实现数据平移</li>
                        <li>一键智能排产：按照约束条件，对订单进行更优排程，提高订单交付绩效</li>
                        <li>建立设备档案：维护设备基础数据、加工能力、产量，便于精准化排产</li>
                        <li>设备高效利用构建：实现设备对接、数据采集、智能反控，与精细排程完成高效联动</li>
                        <li>构建双向质量追溯：“原材料-生产过程量-产成品-售后”的全生命周期质量管理，助于客户在必要时采取措施，例如召回产品或更换原材料</li>
                        <li>改造物料流转方式：辅料视觉识别自动取重、中转晾架安装二维码标记、胶条自动化转运等</li>
                        <li>数据实时监控：设备故障、物料短缺、质量异常、工艺异常等异常情况，及时发出警告</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>应用价值
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>各分厂生产成本差异由原来±30%，缩减到±5%，仅此一项为企业每年节约成本近千万元</li>
                        <li>数据线上化，实时共享，减少人员动作浪费，提升工人工作效率10%</li>
                        <li>实时监控设备运行状态，快速定位生产瓶颈，实现最优化排产，排产效率提升200%，排产效果提升30%</li>
                        <li>实现透明化管理，集团管理效率提升30%</li>
                        <li>实现执行力与人员绩效的高度统一</li>
                        <li>提供大数据分析，为领导提供更加有效和直观的辅助决策</li>
                        <li>挖掘数字化潜力，实现生产进度、质量信息、设备信息、物料信息、报警信息、成本与绩效信息等协同管理</li>
                        <li>打破信息孤岛、融合全集团各业务环节数据，将各分子公司数据做横向对比，基于数据统筹分析，指导未来生产决策</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "casePage3"
}
</script>

<style scoped>

</style>
